import React from 'react'
import {
	Input,
	Button
} from 'reactstrap'
import Reflux from 'reflux'
// import FontAwesome from 'react-fontawesome'

import CurrentRecipeStore from '~/stores/currentRecipe.js'
import CurrentRecipeActions from '~/actions/currentRecipe.js'

import ModalConfirm from '~/modules/_shared/modalConfirm.jsx'


export default class RecipeInstructionsEditRow extends Reflux.Component {
	constructor(props) {
		super(props)

		this.state = {
			showIcons: false,
			showDeleteConfirm: false,
			isEditing: false,
			instruction: props.instruction
		}

		this.store = CurrentRecipeStore
		this.storeKeys = [
			'recipeInstructions'
		]

		this.toggleEdit = this.toggleEdit.bind(this)
		this.toggleDeleteConfirm = this.toggleDeleteConfirm.bind(this)
		this.handleShowIcons = this.handleShowIcons.bind(this)
		this.handleHideIcons = this.handleHideIcons.bind(this)
	}

	// --------------------------------------------------------------------------------
	// --------------------------------------------------------------------------------

	toggleDeleteConfirm() {
		this.setState({ showDeleteConfirm: !this.state.showDeleteConfirm })
	}

	// --------------------------------------------------------------------------------
	// --------------------------------------------------------------------------------

	toggleEdit() {
		this.setState({
			isEditing: !this.state.isEditing,
			instruction: this.props.instruction
		})
	}


	// --------------------------------------------------------------------------------
	// --------------------------------------------------------------------------------

	handleShowIcons() {
		this.setState({ showIcons: true })
	}


	// --------------------------------------------------------------------------------
	// --------------------------------------------------------------------------------

	handleHideIcons() {
		this.setState({ showIcons: false })
	}

	// --------------------------------------------------------------------------------
	// --------------------------------------------------------------------------------

	handleChangeInstruction = (event) => {
		this.setState({
			instruction: event.target.value
		})
	}

	// --------------------------------------------------------------------------------
	// --------------------------------------------------------------------------------

	saveEdit = () => {
		CurrentRecipeActions.updateInstruction(
			{
				recipeInstructionsID: this.props.recipeInstructionsID,
				instruction: this.state.instruction
			},
			this.toggleEdit
		)
	}

	// --------------------------------------------------------------------------------
	// --------------------------------------------------------------------------------

	render() {
		const rowNum = this.props.index + 1

		return (
			<tr>
				<td className="text-right">
					{rowNum}
				</td>

				{
					this.state.isEditing === false &&

					<React.Fragment>
						<td>
							{this.props.instruction}
						</td>
						<td>
							<Button
								block
								size="sm"
								color="primary"
								onClick={this.toggleEdit}
							>
								Edit
							</Button>
						</td>
						<td>
							<Button
								block
								outline
								size="sm"
								onClick={this.toggleDeleteConfirm}
								color="warning"
							>
								Delete
							</Button>

							{
								this.state.showDeleteConfirm === true &&

								<ModalConfirm
									show={this.state.showDeleteConfirm}
									message={`Are you sure you want to remove the step "${this.props.instruction}"`}
									handleConfirm={
										() => {
											CurrentRecipeActions.deleteRecipeInstruction(
												this.props.recipeInstructionsID,
												this.toggleDeleteConfirm
											)
										}
									}
									handleCancel={this.toggleDeleteConfirm}
								/>
							}
						</td>
					</React.Fragment>
				}

				{
					this.state.isEditing === true &&

					<React.Fragment>
						<td>
							<Input
								name="step"
								id="step"
								type="text"
								value={this.state.instruction}
								bsSize="sm"
								onChange={this.handleChangeInstruction}
							/>
						</td>
						<td>
							<Button
								color="primary"
								size="sm"
								block
								onClick={this.saveEdit}
							>
								Save
							</Button>
						</td>
						<td>
							<Button
								onClick={this.toggleEdit}
								color="secondary"
								size="sm"
								block
							>
								Cancel
							</Button>
						</td>
					</React.Fragment>
				}
			</tr>
		)
	}
}



// WEBPACK FOOTER //
// ./src/modules/recipeInstructions/editRow.jsx